import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormFieldConfig } from '../dropdown/form_field_config';
import { TemplateService } from 'src/app/services/template.service';
import { UserService } from 'src/app/admin/core/services/user.service';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.css'],
})
export class MultiSelectDropdownComponent implements OnInit {
  @Input() config: FormFieldConfig;
  @Input() data: any;
  value: any = {};
  dropdownList: any = [];
  typeName: any;

  constructor(
    private templateService: TemplateService,
    public userService: UserService
  ) {}

  ngOnInit(): void {
    // make a call to the backend to get the dropdown values
    this.populateDropdown();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.config.id = '4';
      this.config = changes['config'].currentValue;
      this.typeName = this.config.typeName;
      if (this.config.value) {
        this.value = this.config.value;
      }
    }
  }

  populateDropdown() {
    this.templateService
      .getDropDownValues(`parametre/nomtable/${this.config.parameterLinkName ? this.config.parameterLinkName : this.config.parametreName}`)
      .subscribe((data) => {
        this.config.dropdownList = data;

        const ids = this.config.value?.map((el:any) => el?.parameterId ? el.parameterId : el);

        if (ids) {
          const val: any[] = [];
          for (let i = 0; i < ids?.length; i++) {
            const v = this.config.dropdownList.find((el: any) => el.id === ids[i]);
            if (v) val.push(v);
          }
  
          this.config.value = val;
          this.value = this.config.value;
        }
      });
  }

  compareValeurs(o1: any, o2: any): boolean {
    if (o1 && o2) {
      return o1.id === o2.id;
    }
    return false;
  }
}
